<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202509-2_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202509-2_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-right"><span>見た目ケア外側だけで大丈夫？</span><br>2人に1人が期待する<br>"骨の健康維持"による美容効果</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">忘れがちな「美容と骨の関係」に注目</h3>
        <p class="mb-3">スキンケアやメイク、ヘアケアなど、毎日の習慣として「外側のケア」に時間をかけている方は多いのではないでしょうか。</p>
        <p class="mb-3">しかし最近では、「肌や髪だけでなく、身体の“内側”から整えることが本当の美しさにつながる」という考え方が広がっています。</p>
        <p>なかでも注目を集めているのが、私たちの健康と美を支える“骨”です。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509-2_02.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509-2_03.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <p class="mb-3">姿勢やフェイスライン、若々しい印象など、見た目を左右する多くの要素が、実は骨の健康と深く関係していることがわかってきました。</p>
        <p class="mb-3">そこでマナビス化粧品では、美容と健康の両面から「骨と美の関係」に焦点を当て、20〜50代の男女を対象にした調査を実施しました。</p>
        <p>今回はその結果をもとに、外側からだけでは見えない“美の土台”について考えてみたいと思います。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">美意識の中心は「肌」。その中で目をひく“骨格から整う美しさ”への関心度。</h3>
        <p class="mb-3">まずは「見た目の美しさや健康のために大切にしたい要素」を尋ねたところ、『肌（65.9％）』『髪（48.4％）』『歯（30.6％）』と続き、多くの人が外見をつくるパーツを重視していることがわかります。</p>
        <p class="mb-3">なかでも“肌”は依然として美の象徴として位置づけられており、「透明感」や「ハリ」「トーンの均一さ」といったキーワードが、今もなお美容意識の中心にあります。</p>
        <p class="mb-3">しかし、その一方で注目を集めているのが、“骨格から整える美しさ”です。</p>
        <p class="mb-3">姿勢やフェイスラインなど、見た目の印象を左右する根本的な要素に対し、「内側の土台を整えることが外側の美しさにつながる」という考え方が広がっています。</p>
        <p>つまり、スキンケアやメイクと同じように、骨の健康を保つことも「美容ケアの一部」として捉えられ始めているのです。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509-2_04.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509-2_05.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">“若々しさ”と“健康”は表裏一体。美容意識の背景にあるリアルな本音</h3>
        <p class="mb-3">では、人々はなぜ特定のパーツを大切にしたいと感じているのでしょうか。</p>
        <p class="mb-3">調査からは、「若々しい印象を与えたいから」「年をとっても元気でいたいから」「日々のコンディションを整えたいから」というコメントが続きました。</p>
        <p class="mb-3">この結果から、“見た目の若々しさ”だけでなく、“体の調子を整えたい”という健康意識が美容行動の背景にあることがわかります。</p>
        <p class="mb-3">美肌づくりやヘアケアなど、これまで外見中心だったケアに加えて、「内側の健康を整えることが美しさを支える」という考え方が、幅広い世代に浸透してきているようです。</p>
        <p class="mb-3">外見の印象をつくるのは、肌や髪だけではありません。</p>
        <p class="mb-3">「骨格」「姿勢」「フェイスライン」といった“体の構造”もまた、年齢を重ねるごとに変化し、印象を大きく左右します。</p>
        <p>こうした“見た目と健康の接点”こそが、今あらためて注目されている美容テーマなのです。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">骨がゆがむと美しさも変わる？美容を支える“見えない土台”に注目</h3>
        <p class="mb-3">美容意識が高まる今、見た目の美しさを支える“内側の土台”にも注目が集まっています。</p>
        <p class="mb-3">調査では、「骨の健康が美容に影響する」と感じたときに気になることとして、『栄養バランスの偏り（カルシウム・ビタミン不足など）』『デスクワークやスマホによる姿勢の悪化』『運動不足による骨の衰え』が上位に挙がりました。</p>
        <p class="mb-3">座り姿勢やスマホ操作が続く現代では、骨への負担が日常的に積み重なりやすく、フェイスラインや姿勢の崩れとして現れることもあります。</p>
        <p class="mb-3">また、「日光を浴びる時間が少ない」「日焼け止めの使用でビタミンDが不足しやすい」といった声も見られ、紫外線対策などの美容習慣が、思わぬ形で骨の健康に影響を与えていることもわかりました。</p>
        <p>こうした結果から、見た目の美しさを保つためには“外側のケア”だけでなく、“骨の健康を支える内側のケア”が欠かせないことがうかがえます。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509-2_06.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509-2_07.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">骨を整えると見た目が変わる？スタイル・たるみ・歯の健康にも好影響</h3>
        <p class="mb-3">では、骨の健康を維持できたとき、どのような美容面での変化を期待しているのでしょうか。</p>
        <p class="mb-3">調査では、『スタイルがきれいに見える（47.1％）』『歯の健康が保てる（35.0％）』『たるみケアにつながる（33.0％）』という回答が上位を占めました。</p>
        <p>骨格が整うことで、姿勢が美しく見えるだけでなく、フェイスラインが引き締まり、全体の印象が若々しくなると感じている人が多いようです。</p>
      </div>
    </div>

    <div class="pt-5 mt-5 text-center">
      <p class="mb-5">骨」は肌や筋肉を支える“見えない土台”であり、バランスの取れた骨格は、<br>すっきりとした輪郭や自然な立ち姿をつくる重要な要素です。</p>
      <p class="mb-5">また、歯や噛み合わせの変化を通じて“老け見え”を感じる人も少なくなく、<br>加齢による骨密度の低下が美容面に与える影響を意識する声も増えています。</p>
      <p>つまり、骨の健康を守ることは、見た目の印象を保つうえで<br>欠かせない“美容の基礎ケア”といえるのです。</p>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">日常に取り入れやすい“骨ケア習慣”とは？</h3>
        <p class="mb-3">骨の健康の大切さを感じながらも、実際にどのようにケアしている人が多いのでしょうか。</p>
        <p class="mb-3">「骨を健康に保つために取り組んでいること」として『運動』『姿勢を意識する』『サプリメントを摂る』が上位に挙がりました。</p>
        <p class="mb-3">軽い運動を続けたり、デスクワーク中の姿勢を意識したりと、日常の延長でできる“ながら骨ケア”が主流のようです。</p>
        <p class="mb-3">また、食事だけでは補いにくいカルシウムやビタミンDなどを、サプリメントで効率的に取り入れる方も増えています。</p>
        <p class="mb-3">骨の健康を保つことは、特別なことを始めるというよりも、毎日の小さな意識の積み重ね。</p>
        <p>ライフスタイルの中に自然と“骨を意識する時間”を取り入れることが、美しさを長く保つ第一歩といえそうです。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509-2_08.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509-2_09.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">骨ケアを続ける理由、続けられない理由</h3>
        <p class="mb-3">では、こうした取り組みを実践しているのは、どんな思いからなのでしょうか。</p>
        <p class="mb-3">調査では、「骨の健康維持に取り組む理由」として最も多かったのが『年をとっても元気で歩き続けるため』、次いで『美容やスタイル維持のため』『身体を動かしやすくするため』が挙がりました。</p>
        <p class="mb-3">“健康寿命をのばしたい”という思いが根底にありながらも、見た目やスタイルを保ちたいという美容意識も強く、骨ケアが「健康」と「美」の両面を支える存在になっていることがうかがえます。</p>
        <p>一方で、骨の健康維持に取り組めていない人も少なくないようです。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">骨と美を支える成分は？ビタミンD・カルシウム・コラーゲンが上位に</h3>
        <p class="mb-3">美容や健康のために「積極的に摂りたい」と思う成分を尋ねたところ、『ビタミン類（C・D・Eなど』が最も多く、続いて『カルシウム』『コラーゲン』が上位に挙がりました。</p>
        <p class="mb-3">ビタミンDは骨の形成をサポートするだけでなく、肌のうるおいや免疫にも関係する重要な栄養素として注目されています。</p>
        <p class="mb-3">また、カルシウムは歯や骨の構成成分として基本でありながら、現代の食生活では不足しやすい栄養素の一つです。</p>
        <p>そしてコラーゲンは、肌の弾力やハリを支える成分として知られ、内側からの美しさを意識する人たちの間で根強い人気を保っています。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509-2_10.jpg">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202509-2_11.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">“食事派”と“サプリ派”、それぞれのインナーケア習慣</h3>
        <p class="mb-3">では、それらの成分をどのように摂りたいと考えているのでしょうか。</p>
        <p class="mb-3">『食事やフルーツなど自然な形で摂取したい』『サプリメントで効率的に摂取したい』と続き、食事から栄養を取り入れたいという声が多い一方で、忙しい日常の中では必要な量を十分に摂るのが難しいという課題もあります。</p>
        <p class="mb-3">そのため、サプリメントを活用して不足しがちな栄養を補う“賢い選択”をする人が増えています。</p>
        <p>毎日の食事とサプリメントをバランスよく取り入れながら、内側から美しさを支える意識が、今の美容トレンドの主流になりつつあるようです。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-25">
        <img src="@/assets/img/column/202509-2_12.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-75">
        <h2 class="mb-3">美しさは「外側」から「内側」へ。<br>骨からはじまる新しい美容習慣</h2>
        <p class="mb-3">今回の調査から、美容意識は確実に「外側」から「内側」へと広がっていることがわかりました。 スキンケアやメイクで見た目を整えるだけでなく、栄養や姿勢、骨格といった“体の土台”を意識する人が増えています。</p>
        <p>外見の美しさを支えているのは、実は目に見えない内側のバランス。 姿勢やフェイスラインの変化、たるみなどの悩みの背景には、骨や筋肉のコンディションが深く関わっています。 つまり、美しさの源は「肌」だけでなく「骨」にもあるのです。</p>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3">手軽に、無理なく。</p>
        <p class="mb-3 fs-2">“骨から美を育てる”インナーケアを</p>
        <p class="mb-3">骨の健康を保つことは、難しい特別なケアではありません。<br>毎日の生活の中で姿勢を意識したり、食事でカルシウムを摂ったり、そして足りない栄養をサプリメントで補ったりと、続けやすい小さな習慣の積み重ねが大切です。</p>
        <p class="mb-3">マナビス化粧品では、外側と内側の両面から美しさを支えることを大切にしています。<br>“骨から美を育てる”という新しい視点で、これからのインナーケアをはじめてみませんか？</p>
        <p>次回は、そんな考え方に基づいて開発されたマナビス化粧品のビタミンD3配合サプリメントをご紹介します。<br>骨の健康と美容を同時に叶える“美の新常識”を、ぜひチェックしてみてください。</p>
      </div>
    </div>

    <div class="text-center mb-5 pb-5">
      <p>アンケートの詳細は以下からご覧いただけます。</p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000016.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000016.000124389.html">「外側のケアだけで大丈夫？」2人に1人が“骨の健康維持でスタイルが整う”と期待！美容と骨の関係について徹底調査</a></p>
    </div>

    <div class="rte">
      <font size="1">
        <p>調査概要：「身体の内側からの美容意識」に関する調査<br>
        【調査期間】2025年9月10日（水）～2025年9月11日（木）<br>
        【調査方法】「PRIZMA」によるインターネット調査<br>
        【調査人数】1,008人<br>
        【調査対象】調査回答時に美容・健康意識の高い20～50代の男女と回答したモニター<br>
        【調査元】株式会社マナビス化粧品<br>
        【モニター提供元】PRIZMAリサーチ<br>
        ※この調査の内容は、あくまでアンケート結果の紹介であり、効果や効能を実証するものではありません。</p>
      </font>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}
ul {
  list-style: disc;
  margin-left: 25px;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  /* padding: 10px; */
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide img {
  width: 100%;
  height: 422px;
  object-fit: cover;
}
.img-top-slide_text {
  position: absolute;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
    .img-top-slide_text {
      left: 10px;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .w-25 {
    width: 25%;
   }
   .w-75 {
    width: 75%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
   .img-top-slide img {
    height: 650px;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>